import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { MuiChipsInput } from 'mui-chips-input';

import Button from 'components/Button';
import FieldRow from 'components/FormElements/FieldRow';
import GridContainer from 'components/GridContainer';

import { useFirm } from 'hooks/data/firm/useFirm';

interface Props {
  associatedFirmIds: Array<string>;
  associateFirm: (firmId: string) => void;
  disassociateFirm: (index: number) => void;
  clearAssociatedFirms: (chips: Array<string>) => void;
}

const MuiChipsInputStyled = styled(MuiChipsInput)({
  '& .MuiChipsInput-Chip': {
    marginTop: '5px',
  },
});

const AssociatedFirms: React.FC<Props> = ({
  associatedFirmIds,
  associateFirm,
  disassociateFirm,
  clearAssociatedFirms,
}) => {
  const firmsResponse = useFirm({ params: {} });
  const firms = firmsResponse.firms?.data?.result ?? [];
  const [addAssociatedFirmMenuAnchor, setAddAssociatedFirmMenuAnchor] =
    useState<HTMLButtonElement | null>(null);

  return (
    <FieldRow>
      <GridContainer>
        <Grid size={{ xs: 12, sm: 'grow' }}>
          <MuiChipsInputStyled
            label="Associated firms"
            placeholder=""
            fullWidth
            size="small"
            variant="outlined"
            disableEdition={true}
            contentEditable={false}
            inputMode="none"
            value={associatedFirmIds.map((firmId) => {
              const associatedFirm = firms.find((firm) => firm._id === firmId);
              return associatedFirm?.firmName ?? '';
            })}
            onDeleteChip={(_, index) => disassociateFirm(index)}
            onChange={clearAssociatedFirms}
            slotProps={{
              htmlInput: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 'auto' }} alignContent="center">
          <Button
            aria-controls="add-associated-firm-menu"
            aria-haspopup="true"
            variant="outlined"
            endIcon={<KeyboardArrowDown />}
            onClick={(event) =>
              setAddAssociatedFirmMenuAnchor(event.currentTarget)
            }
          >
            Add new associated firm
          </Button>
          <Menu
            id="add-associated-firm-menu"
            anchorEl={addAssociatedFirmMenuAnchor}
            keepMounted
            open={Boolean(addAssociatedFirmMenuAnchor)}
            onClose={() => setAddAssociatedFirmMenuAnchor(null)}
          >
            {firms
              .filter((firm) => !associatedFirmIds.includes(firm._id))
              .map((firm) => (
                <MenuItem
                  key={firm._id}
                  onClick={() => {
                    associateFirm(firm._id);
                    setAddAssociatedFirmMenuAnchor(null);
                  }}
                >
                  {firm.firmName}
                </MenuItem>
              ))}
          </Menu>
        </Grid>
      </GridContainer>
    </FieldRow>
  );
};

export default AssociatedFirms;
